// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2dPUI","log":"ModalInventoryLogs_log__24gsP","date":"ModalInventoryLogs_date__2iJpd","userName":"ModalInventoryLogs_userName__1-xfV"};